import { Progress } from 'antd';
import moment from 'moment';
import { useEffect, useState, VFC } from 'react';

interface RefetchIndicatorProps {
  /**
   * Refetch interval in milliseconds
   */
  refetchInterval: number;
  /**
   * Time to start count from
   */
  fetchStart: Date | undefined;
}

export const RefetchIndicator: VFC<RefetchIndicatorProps> = ({ refetchInterval, fetchStart }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!fetchStart) {
      return () => {};
    }
    const interval = setInterval(() => {
      const diff = moment().diff(fetchStart, 'milliseconds');
      const percentage = Math.round((diff / refetchInterval) * 100);
      setProgress(percentage);
    }, 100);

    return () => clearInterval(interval);
  }, [fetchStart, refetchInterval]);

  return <Progress percent={progress} showInfo={false} />;
};
